/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum that defines all possible filter types.
 */
export var FilterType;
(function (FilterType) {
    FilterType["TIME_RANGE"] = "timeRange";
})(FilterType || (FilterType = {}));
